/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable prefer-rest-params */
import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import Navigation from '@/components/Navigation';
import { BaseComponentProps } from '@/types';
import Footer from '@/components/Footer';
import PricingModalComponent from '@/components/PricingModal';
import Link from '@/components/Link';
// import CalendarBooking from '@/views/calendar-booking';
import { ArrowDown, ArrowUp } from '@/components/icons/Arrows';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useCurrencyStore } from '@/store/currency';

const currencies = [`US$`, `CA$`];

declare global {
  interface Window {
    dataLayer: any[];
  }
}

type LayoutProps = {
  title: string;
  description: string;
  active?: string;
};

function NavigationItems(props: any) {
  const { setToggleMobileMenu, toggleMobileMenu, active = undefined } = props;
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { currency, setCurrency } = useCurrencyStore();

  const handleMouseEnter = () => {
    setDropdownOpen(true);
  };

  const handleMouseLeave = () => {
    setDropdownOpen(false);
  };

  // async function handleBlogClicked(evt: any) {
  //   evt?.preventDefault();
  //   await Mixpanel.track(`View Blog`);
  //   if (typeof window !== `undefined`) {
  //     window.open(`https://medium.com/@VitractOfficial`, `_blank`);
  //   }
  // }

  return (
    <div className="h-[83px] sm:max-w-[82%] mx-auto md:mx-auto overflow-hidden">
      <ToastContainer />
      <div className="flex items-center justify-center w-full h-full md:justify-between">
        <div className="flex items-center justify-center w-full h-full md:justify-between">
          <div className="h-full flex justify-start gap-x-[32px] text-gray-dark text-[14px]">
            <ul className="items-center hidden xl:flex gap-x-8">
              <li
                className={`h-full flex items-center ${
                  active === `vitract-university` &&
                  `md:border-b-[4px] md:border-primary`
                }`}
              >
                <Link
                  href="/vitract-university"
                  className="text-navy-blue font-medium text-[16px] hover:text-[#FF713F]"
                >
                  Vitract University
                </Link>
              </li>
              {/* <button
                className="text-[16px] text-navy-blue font-medium mr-[30px] md:mr-auto hover:text-[#FF713F]"
                onClick={handleBlogClicked}
                type="button"
              >
                Blog
              </button> */}
              <li
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                className={`h-full flex items-center ${
                  active === `blog-page` &&
                  `md:border-b-[4px] md:border-primary`
                }`}
              >
                <div className="cursor-pointer text-[16px] text-navy-blue font-medium mr-[30px] md:mr-auto hover:text-[#FF713F]">
                  Research
                </div>
                {dropdownOpen && (
                  <div className="w-[140px] flex flex-col absolute top-[60px] bg-[#FFF] border border-solid border-[#E6E6E6] py-6 px-4 rounded-lg gap-y-5 z-50">
                    <Link
                      href="/blogs"
                      className="text-[16px] text-navy-blue font-medium hover:text-[#FF713F]"
                    >
                      Blog
                    </Link>
                    <Link
                      href="/science"
                      className="text-navy-blue font-medium text-[16px] hover:text-[#FF713F]"
                    >
                      Science
                    </Link>
                  </div>
                )}
              </li>
              <li
                className={`h-full flex items-center ${
                  active === `pricing` && `lg:border-b-[4px] lg:border-primary`
                }`}
              >
                <Link
                  href="/pricing"
                  className="text-navy-blue font-medium text-[16px] hover:text-[#FF713F]"
                >
                  Pricing
                </Link>
              </li>
            </ul>
          </div>

          <div className="h-full gap-x-[77.91px] md:gap-x-[0px] flex items-center justify-center xl:pl-8">
            <Link href="/">
              <img
                src="/images/logo.svg"
                alt="Vitract | Using personalized nutrition to treat depression"
                className="h-[25px] ml-[30px] md:ml-[0px] md:mr-[205px] lg:mr-[300px] xl:mr-0 xl:ml-0"
              />
            </Link>
          </div>
          <div className="flex items-center justify-center">
            <div className="h-full flex justify-end xl:ml-[150px] text-gray-dark text-[14px]">
              <ul className="items-center hidden xl:flex gap-x-8">
                <li className="flex items-center h-full">
                  <Link
                    href="https://app.vitract.com/practitioner-registration"
                    target="_blank"
                    className="text-navy-blue font-medium text-[16px] hover:text-[#FF713F]"
                  >
                    Practitioners
                  </Link>
                </li>
                <li className="flex items-center h-full">
                  <Link
                    href="https://app.vitract.com"
                    target="_blank"
                    className="text-navy-blue font-medium text-[16px] hover:text-[#FF713F]"
                  >
                    Login
                  </Link>
                </li>
              </ul>
              <ul className="items-center hidden ml-8 xl:flex">
                <li className="mr-4">
                  {/* <Button
                text="Shop"
                className="text-white bg-primary px-[20px] py-[10px] rounded-[4px] text-sm font-medium"
                onClick={() => handleSignUp(null, `waitlist`)}
              /> */}
                  <Link
                    href="/pricing"
                    className="text-[#FFFFFF] bg-primary px-[36.5px] py-[10px] rounded-[4px] text-sm font-medium hover:bg-navy-blue hover:shadow-2xl hover:scale-[1.015] transition-all duration-[0.1s] ease-in-out"
                  >
                    Shop
                  </Link>
                </li>
                {/* <li>
                  <CalendarBooking />
                </li> */}
                <li className="ml-4">
                  <div className="flex items-center">
                    {currencies.map((item, index) => (
                      <button
                        type="button"
                        onClick={() => setCurrency(item)}
                        className={`
                          px-4 py-2 border font-bold
                          ${
                            index === 0
                              ? `rounded-l-md border border-r-0`
                              : `rounded-r-md border border-l-0`
                          }  
                          ${
                            currency === item
                              ? `bg-primary border-primary text-white`
                              : `border-[#19233F] text-[#19233F]`
                          }
                          hover:bg-primary hover:border-primary hover:text-white
                        `}
                      >
                        {item}
                      </button>
                    ))}
                  </div>
                </li>
              </ul>
            </div>
            <div className="h-full flex justify-end gap-x-[37px] text-gray-dark text-[14px]">
              <ul className="items-center justify-between hidden md:flex xl:hidden gap-x-5">
                <li>
                  {/* <Button
                text="Shop"
                className="text-white bg-primary px-[20px] py-[10px] rounded-[4px] text-sm font-medium"
                onClick={() => handleSignUp(null, `waitlist`)}
              /> */}
                  <Link
                    href="/pricing"
                    className="text-[#FFFFFF] bg-primary px-[36.5px] py-[10px] rounded-[4px] text-sm font-medium hover:bg-navy-blue hover:shadow-2xl hover:scale-[1.015] transition-all duration-[0.1s] ease-in-out"
                  >
                    Shop
                  </Link>
                </li>
                {/* <li>
                  <CalendarBooking />
                </li> */}
                <li>
                  <div className="flex items-center">
                    {currencies.map((item, index) => (
                      <button
                        type="button"
                        onClick={() => setCurrency(item)}
                        className={`
                          px-4 py-2 border font-bold
                          ${
                            index === 0
                              ? `rounded-l-md border border-r-0`
                              : `rounded-r-md border border-l-0`
                          }  
                          ${
                            currency === item
                              ? `bg-primary border-primary text-white`
                              : `border-[#19233F] text-[#19233F]`
                          }
                          hover:bg-primary hover:border-primary hover:text-white
                        `}
                      >
                        {item}
                      </button>
                    ))}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <button
          type="button"
          className="lg:w-fit mr-[30px] md:ml-[30px] lg:mr-[0px] rounded-md xl:hidden flex justify-end"
          onClick={setToggleMobileMenu}
        >
          {!toggleMobileMenu ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6 stroke-current"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={1.5}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          )}
        </button>
      </div>
    </div>
  );
}

export default function Layout(props: BaseComponentProps & LayoutProps) {
  const { children, description, title, active } = props;
  const [toggleMobileMenu, setToggleMobileMenu] = useState(false);
  const [togglePricingModal, setTogglePricingModal] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { currency, setCurrency } = useCurrencyStore();

  function handleClick() {
    setDropdownOpen(!dropdownOpen);
  }

  // async function handleBlogClicked(evt: any) {
  //   evt?.preventDefault();
  //   await Mixpanel.track(`View Blog`);
  //   if (typeof window !== `undefined`) {
  //     window.open(`https://medium.com/@VitractOfficial`, `_blank`);
  //   }
  // }

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href="https://vitract.com" />
        <script defer id="mcjs">
          {`!function(c,h,i,m,p){m=c.createElement(h),p=c.getElementsByTagName(h)[0],m.async=1,m.src=i,p.parentNode.insertBefore(m,p)}(document,"script","https://chimpstatic.com/mcjs-connected/js/users/b3a74adf59f0c96f88daec5c3/a2d99679e4c859ee5a0b18939.js");`}
        </script>
      </Helmet>

      <main id="main-layout" className="overflow-hidden">
        <PricingModalComponent
          open={togglePricingModal}
          setOpen={setTogglePricingModal}
        />
        <Navigation className="bg-white nav fixed w-full z-[9999] top-0">
          {/* <div
            className="flex items-center justify-center px-4 py-[23.5px] bg-navy-blue bg-university-header-background md:px-0"
            data-aos="slide-down"
          >
            <div className="flex flex-col max-w-[335px] md:max-w-[710px] xlg:max-w-[1034px] text-[#FFF]">
              <div className="flex flex-col md:flex-row gap-x-3 items-center justify-center text-[32px] md:text-[40px] font-bold">
                <div className="flex gap-x-3">
                  <span className="text-[40px]">🎄</span>
                  <p className="text-center text-[20px] md:text-[40px] font-[900]">
                    Holiday Sale Now Live! {` `}
                  </p>
                </div>
                <Link
                  href="/pricing"
                  className="flex justify-center items-center text-white bg-primary text-[18px] md:text-[32px] leading-3 md:leading-6 font-[900] p-3 md:p-5 rounded"
                >
                  Shop Now
                </Link>
              </div>
              <div className="flex items-center justify-center gap-x-3">
                <p className="text-center text-[20px] md:text-[40px] font-[900] py-3">
                  and save – ends 11:59 PM ET, December 27, 2024!
                </p>
                <span className="text-[40px]">🎄</span>
              </div>
            </div>
          </div> */}
          {/* <Link href="/pricing">
            <div
              className="flex flex-col lg:flex-row items-center justify-center px-4 py-2 bg-navy-blue md:px-0 gap-1 min-h-[62px]"
              data-aos="slide-down"
            >
              <span className="text-center text-white text-xs sm:text-base">
                July 4th Sales!! - get <strong>$30</strong> off DeepGut Tests.
              </span>
              <span className="text-center text-white text-xs sm:text-base">
                To claim this offer, use discount code
                <span className="font-bold text-primary"> INDEPENDENCE30 </span>
                at checkout.
              </span>
            </div>
          </Link> */}
          <NavigationItems
            toggleMobileMenu={toggleMobileMenu}
            setToggleMobileMenu={() => setToggleMobileMenu(!toggleMobileMenu)}
            active={active}
            handleSignUp={() => setTogglePricingModal(true)}
          />
          <div
            className={`px-[30px] border-y-2 pt-[10px] pb-[20px] border-gray-50 ${
              toggleMobileMenu
                ? `block transition-all ease-in-out delay-150 duration-300`
                : `hidden`
            }`}
          >
            <ul className={toggleMobileMenu && `grid gap-4 items-center`}>
              <li
                className={`h-full flex items-center xl:hidden ${
                  active === `science` && `md:border-b-[4px] md:border-primary`
                }`}
              >
                <Link
                  href="/vitract-university"
                  className="text-navy-blue font-medium text-[16px] hover:text-[#FF713F]"
                >
                  Vitract University
                </Link>
              </li>
              <li
                onClick={handleClick}
                className={`h-full flex flex-col xl:hidden ${
                  active === `blog-page` &&
                  `md:border-b-[4px] md:border-primary`
                }`}
              >
                {/* <button
                  className="text-[16px] text-navy-blue font-medium mr-[30px] md:mr-auto hover:text-[#FF713F]"
                  onClick={handleBlogClicked}
                  type="button"
                >
                  Blog
                </button> */}
                <div className="flex text-[16px] text-navy-blue font-medium hover:text-[#FF713F]">
                  Research{` `}
                  <span className="py-[2px] pl-2">
                    {dropdownOpen ? <ArrowUp /> : <ArrowDown />}
                  </span>
                </div>
                {dropdownOpen && (
                  <div className="flex flex-col gap-y-4 pt-4">
                    <Link
                      href="/blogs"
                      className="text-[16px] text-navy-blue font-medium hover:text-[#FF713F]"
                    >
                      Blog
                    </Link>
                    <Link
                      href="/science"
                      className="text-navy-blue font-medium text-[16px] hover:text-[#FF713F]"
                    >
                      Science
                    </Link>
                  </div>
                )}
              </li>
              <li
                className={`h-full flex items-center xl:hidden ${
                  active === `pricing` && `md:border-b-[4px] md:border-primary`
                }`}
              >
                <Link
                  href="/pricing"
                  className="text-navy-blue font-medium text-[16px] hover:text-[#FF713F]"
                >
                  Pricing
                </Link>
              </li>
              <li className="flex items-center h-full xl:hidden">
                <Link
                  href="https://app.vitract.com/practitioner-registration"
                  target="_blank"
                  className="text-navy-blue font-medium text-[16px] hover:text-[#FF713F]"
                >
                  Practitioners
                </Link>
              </li>
              <li className="flex items-center h-full xl:hidden">
                <Link
                  href="https://app.vitract.com"
                  target="_blank"
                  className="text-navy-blue font-medium text-[16px] hover:text-[#FF713F]"
                >
                  Login
                </Link>
              </li>
              <li className="pt-[10px] md:hidden">
                {/* <Button
                  text="Pre-Order"
                  className="text-white bg-primary px-[20px] py-[10px] rounded-[4px] text-sm font-medium"
                  onClick={() => setTogglePricingModal(true)}
                /> */}

                <Link
                  href="/pricing"
                  className="text-[#FFFFFF] bg-primary px-[36.5px] py-[10px] rounded-[4px] text-sm font-medium hover:bg-navy-blue hover:shadow-2xl hover:scale-[1.015] transition-all duration-[0.1s] ease-in-out"
                >
                  Shop
                </Link>
              </li>
              {/* <li className="pt-[10px] md:hidden">
                <CalendarBooking />
              </li> */}
              <li className="pt-[10px] md:hidden">
                <div className="flex items-center">
                  {currencies.map((item, index) => (
                    <button
                      type="button"
                      onClick={() => setCurrency(item)}
                      className={`
                          px-4 py-2 border font-bold
                          ${
                            index === 0
                              ? `rounded-l-md border border-r-0`
                              : `rounded-r-md border border-l-0`
                          }  
                          ${
                            currency === item
                              ? `bg-primary border-primary text-white`
                              : `border-[#19233F] text-[#19233F]`
                          }
                          hover:bg-primary hover:border-primary hover:text-white
                        `}
                    >
                      {item}
                    </button>
                  ))}
                </div>
              </li>
            </ul>
          </div>
        </Navigation>
        <main className="mt-[80px]">{children}</main>
      </main>
      <Footer />
    </>
  );
}

Layout.defaultProps = {
  active: undefined,
};
